import { Common } from "@common/types";
import React from "react";

export interface FormFieldContextProps {
  onLoading: (isLoading: boolean) => void;
  onOptionsLoaded: (options: Common.OptionItem<any>[]) => void;
}

export const FormFieldContext = React.createContext<FormFieldContextProps | null>(null);
